import api from './api'

export interface ShipperTowerItem {
  id: string
  kind: 'quote' | 'order'
  stage: 'awaiting_offers' | 'receiving_offers' | 'closed' | 'in_transit' | 'delivered'
  txControl: string
  agentName: string | null
  modality: string | null
  offersCount: number | null
  totalValue: number | null
  currency: string | null
  createdAt: string
  updatedAt: string
}

export async function getShipperControlTower(): Promise<{ items: ShipperTowerItem[]; generatedAt: string }> {
  const res = await api.get('/shipper/control-tower')
  return res.data
}
